<template lang="pug">
  layout()

    //- Toolbar
    template(v-slot:toolbar)
      .navbar.is-beige
        ui-menu.navbar-start(:menu="menu" v-slot="{route, label, icon, attr}")
          router-link.navbar-item(:to="route")
            b-icon.mr-5(v-if="icon" :icon="icon")
            span {{ label }}
            .tags.has-addons.ml-5(v-if="attr.badge")
              b-tag {{attr.badge}}
            b-icon.ml-5(v-if="attr.mark" :icon="attr.mark.icon" :type="attr.mark.style" size="is-small")

        .navbar-end
          .navbar-item

            //- .tag.is-warning.is-rounded
              b-icon(icon="alert" size="is-small")
              span Изучить до 15 мая
          //- .navbar-item
            .buttons
              b-button.is-primary(icon-left="check") Я изучил(а) материал

    template(v-slot:content)
      router-view(:document="document")



</template>

<script>
import Document from '../models/Document';
import { mapMutations } from 'vuex';

export default {
  props: {
    id: [Number, String],
  },

  methods: {
    ...mapMutations(['setBreadcrumbsRouteTitle']),
  },

  data: () => ({
    showSidebar: false,
    document: new Document(),
  }),

  computed: {
    menu() {
      return [
        { route: 'docs.view.read', label: 'Просмотр', icon: 'eye' },
        {
          route: 'docs.view.comments',
          label: 'Комментарии',
          icon: 'message',
          attr: { badge: 0 },
        },
        {
          route: { name: 'docs.view.edit' },
          label: 'Редактирование',
          icon: 'pencil',
          attr: {
            mark: this.document.$isChanged ? { icon: 'asterisk', style: 'is-danger' } : null,
          },
        },
        {
          route: { name: 'docs.view.task' },
          label: 'План',
          icon: 'check',
          // attr: {
          //   mark: this.document.$isChanged ? { icon: 'asterisk', style: 'is-danger' } : null,
          // },
        },
      ];
    },
  },

  async created() {
    this.setBreadcrumbsRouteTitle('docs.view', 'Загрузка…');
    if (this.id) {
      await this.document.$find(this.id);
      this.setBreadcrumbsRouteTitle({ 'docs.view': this.document.name });
    }
  },
};
</script>
